import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Slider,
  Checkbox,
  Radio,
  TextField,
  Stack,
} from "@vapor/react-material";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";
import { useTranslation } from "react-i18next";
import VaporTag from "@vapor/react-custom/VaporTag";

export const RischioSectionA = ({
  tenantTypeId,
  sliderVal,
  chbVal,
  textNotes,
  selectedRadioValues,
  currentRischio,
  subTotaleA,
  isUserAllowedToManage,
  onSliderChange,
  onCheckboxChange,
  onRadioChange,
  onTableRowClick,
  sliderLivelli,
  sliderLivelliAvv,
  rischioPaeseCliente,
  rischioProvinciaCliente,
}) => {
  const { t } = useTranslation();

  // Helper function to get text note value for section A
  const getTextNoteValue = (sectionId) => {
    const noteKey = `txtAltro${sectionId}`;
    return textNotes?.[noteKey] || "";
  };

  const renderTableAContent = () => {
    const sections = [
      {
        id: "A1",
        title: tenantTypeId === 3 ? "A.1 - Identità del cliente" : t("valutazione.form.tabellaA.a1"),
        sliderName: "sliderA1",
        checkboxes: tenantTypeId === 1 ? [
          { id: "chbA1_1", label: t("valutazione.form.tabellaA.a1_1") },
          { id: "chbA1_2", label: t("valutazione.form.tabellaA.a1_2") },
          { id: "chbA1_3", label: t("valutazione.form.tabellaA.a1_3") },
          { id: "chbA1_4", label: t("valutazione.form.tabellaA.a1_4") },
          { id: "chbA1_5", label: t("valutazione.form.tabellaA.a1_5") },
        ] : null,
        radios: tenantTypeId === 3 ? [
          { id: "chbA1_1", label: "Ditta individuale" },
          { id: "chbA1_2", label: "Associazione professionale" },
          { id: "chbA1_3", label: "Società di persone" },
          { id: "chbA1_4", label: "Società di capitali" },
          { id: "chbA1_5", label: "Trust" },
          { id: "chbA1_6", label: "Società fiduciaria" },
          { id: "chbA1_7", label: "Persona fisica" },
        ] : null,
        altroField: "chbA1_Altro",
        altroNote: currentRischio?.sp_a1_altro_note,
        altroText: tenantTypeId === 3 ? "Altro" : t("valutazione.form.tabellaA.a1_6"),
      },
      {
        id: "A2",
        title: tenantTypeId === 3 ? "A.2 - Modalità di pagamento dell'onorario" : t("valutazione.form.tabellaA.a2"),
        sliderName: "sliderA2",
        checkboxes: tenantTypeId === 1 ? [
          { id: "chbA2_1", label: t("valutazione.form.tabellaA.a2_1") },
          { id: "chbA2_2", label: t("valutazione.form.tabellaA.a2_2") },
          { id: "chbA2_3", label: t("valutazione.form.tabellaA.a2_3") },
        ] : null,
        radios: tenantTypeId === 3 ? [
          { id: "chbA2_1", label: "Denaro contante" },
          { id: "chbA2_2", label: "Bonifico/assegno" },
        ] : null,
        altroField: "chbA2_Altro",
        altroNote: currentRischio?.sp_a2_altro_note,
        altroText: tenantTypeId === 3 ? "Altro" : t("valutazione.form.tabellaA.a2_4"),
      },
      {
        id: "A3",
        title: tenantTypeId === 3 ? "A.3 - Comportamento del cliente" : t("valutazione.form.tabellaA.a3"),
        sliderName: "sliderA3",
        checkboxes: tenantTypeId === 1 ? [
          { id: "chbA3_1", label: t("valutazione.form.tabellaA.a3_1") },
          { id: "chbA3_2", label: t("valutazione.form.tabellaA.a3_2") },
          { id: "chbA3_3", label: t("valutazione.form.tabellaA.a3_3") },
          { id: "chbA3_4", label: t("valutazione.form.tabellaA.a3_4") },
        ] : null,
        radios: tenantTypeId === 3 ? [
          { id: "chbA3_1", label: "Nella norma (cliente collaborativo/trasparente)" },
          { id: "chbA3_2", label: "Fuori dalla norma(cliente reticente/poco trasparente)" },
        ] : null,
        altroField: "chbA3_Altro",
        altroNote: currentRischio?.sp_a3_altro_note,
        altroText: tenantTypeId === 3 ? "Altro" : t("valutazione.form.tabellaA.a3_5"),
      },
      {
        id: "A4",
        title: tenantTypeId === 3 ? "A.4 - Area geografica di residenza" : t("valutazione.form.tabellaA.a4"),
        sliderName: "sliderA4",
        checkboxes: tenantTypeId === 1 ? [
          { id: "chbA4_1", label: t("valutazione.form.tabellaA.a4_1") },
          { id: "chbA4_2", label: t("valutazione.form.tabellaA.a4_2") },
        ] : null,
        radios: tenantTypeId === 3 ? [
          { id: "chbA4_1", label: "Italia" },
          { id: "chbA4_2", label: "Paesi UE" },
          { id: "chbA4_3", label: "Paesi extra UE" },
          { id: "chbA4_4", label: "Territori off shore" },
        ] : null,
        altroField: "chbA4_Altro",
        altroNote: currentRischio?.sp_a4_altro_note,
        altroText: tenantTypeId === 3 ? "Altro" : t("valutazione.form.tabellaA.a4_3"),
        showGeographicInfo: true,
      },
    ];

    return sections.map((section) => (
      <React.Fragment key={section.id}>
        {/* Section Header with Slider */}
        <TableRow>
          <TableCell colSpan={2}>
            <ExtendedTypography
              variant="subtitle2"
              fontStyle={
                tenantTypeId === 1 || tenantTypeId === 3
                  ? { fontWeight: "bold" }
                  : null
              }
            >
              {section.title}
            </ExtendedTypography>
            {section.showGeographicInfo && (
              <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                {rischioPaeseCliente.paese !== "Italia" ? (
                  <VaporTag
                    variant="standard"
                    label={
                      rischioPaeseCliente.paese +
                      " - " +
                      rischioPaeseCliente.rischio +
                      " (" +
                      rischioPaeseCliente.value +
                      ")"
                    }
                    sx={{
                      ...rischioPaeseCliente.color,
                      mr: 1,
                    }}
                  />
                ) : null}
                {rischioPaeseCliente.paese === "Italia" && rischioProvinciaCliente.found ? (
                  <VaporTag
                    variant="standard"
                    label={
                      rischioProvinciaCliente.provincia +
                      " - " +
                      rischioProvinciaCliente.rischio +
                      " (" +
                      rischioProvinciaCliente.value +
                      ")"
                    }
                    sx={rischioProvinciaCliente.color}
                  />
                ) : null}
              </Stack>
            )}
          </TableCell>
          <TableCell align="center" colSpan={1}>
            <Slider
              id={section.sliderName}
              name={section.sliderName}
              step={1}
              marks={tenantTypeId === 3 ? sliderLivelliAvv : sliderLivelli}
              min={1}
              max={tenantTypeId === 3 ? 5 : 4}
              valueLabelDisplay="auto"
              value={sliderVal[section.sliderName]}
              onChange={onSliderChange}
              disabled={!isUserAllowedToManage}
            />
          </TableCell>
        </TableRow>

        {/* Checkboxes for tenant type 1 */}
        {section.checkboxes && section.checkboxes.map((checkbox) => (
          <TableRow
            key={checkbox.id}
            hover
            onClick={() => onTableRowClick(checkbox.id)}
            sx={{ cursor: "pointer" }}
          >
            <TableCell align="left" width="70%">
              {checkbox.label}
            </TableCell>
            <TableCell align="center" width="15%">
              <Checkbox
                id={checkbox.id}
                checked={chbVal[checkbox.id]}
                onChange={onCheckboxChange}
                disabled={!isUserAllowedToManage}
              />
            </TableCell>
            <TableCell align="center" width="15%"></TableCell>
          </TableRow>
        ))}

        {/* Radio buttons for tenant type 3 */}
        {section.radios && section.radios.map((radio) => (
          <TableRow
            key={radio.id}
            hover
            onClick={() => onRadioChange(radio.id, section.id)}
            sx={{ cursor: "pointer" }}
          >
            <TableCell align="left" width="70%">
              {radio.label}
            </TableCell>
            <TableCell align="center" width="15%">
              <Radio
                checked={selectedRadioValues[section.id] === radio.id}
                id={radio.id}
                value={radio.id}
                name={`radio-${section.id}`}
                inputProps={{ 'aria-label': radio.id }}
              />
            </TableCell>
            <TableCell align="center" width="15%"></TableCell>
          </TableRow>
        ))}

        {/* Altro field */}
        {section.altroField && tenantTypeId !== 2 && (
          <TableRow hover>
            <TableCell align="left" width="70%">
              <Stack direction="column" spacing={1}>
                <ExtendedTypography variant="subtitle2">
                  {section.altroText}
                </ExtendedTypography>
                <TextField
                  id={`txtAltro${section.id}`}
                  key={`txtAltro${section.id}`}
                  label=""
                  size="small"
                  fullWidth
                  multiline
                  rows={2}
                  sx={
                    chbVal[section.altroField]
                      ? { display: "block" }
                      : { display: "none" }
                  }
                  value={getTextNoteValue(section.id)}
                  onChange={(event) => {
                    // Chiama onCheckboxChange con un evento personalizzato per il campo di testo
                    const customEvent = {
                      target: {
                        id: `txtAltro${section.id}`,
                        value: event.target.value,
                        type: 'text'
                      }
                    };
                    onCheckboxChange(customEvent);
                  }}
                  inputProps={{ autocomplete: "nope", maxLength: 1000 }}
                  disabled={!isUserAllowedToManage}
                />
              </Stack>
            </TableCell>
            <TableCell align="center" width="15%">
              <Checkbox
                id={section.altroField}
                checked={chbVal[section.altroField]}
                onChange={onCheckboxChange}
                disabled={!isUserAllowedToManage}
              />
            </TableCell>
            <TableCell align="center" width="15%"></TableCell>
          </TableRow>
        )}
      </React.Fragment>
    ));
  };

  return (
    <TableContainer component={Paper} sx={{ mt: 2 }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell align="left" width="70%">
              <ExtendedTypography
                variant="subtitle2"
                fontStyle={{ fontWeight: "bold" }}
              >
                {t("valutazione.form.tabellaA.titolo")}
              </ExtendedTypography>
            </TableCell>
            <TableCell align="center" width="15%">
              <ExtendedTypography
                variant="subtitle2"
                fontStyle={{ fontWeight: "bold" }}
              >
                {t("valutazione.form.fattoreRischioRiscontrato")}
              </ExtendedTypography>
            </TableCell>
            <TableCell align="center" width="15%">
              <ExtendedTypography
                variant="subtitle2"
                fontStyle={{ fontWeight: "bold" }}
              >
                {t("valutazione.form.livelloRischioSpecifico")}
              </ExtendedTypography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {renderTableAContent()}
          
          {/* Subtotal Row */}
          <TableRow sx={{ backgroundColor: "hsl(199, 100%, 40%)" }}>
            <TableCell colSpan="2" align="right" width="85%">
              <ExtendedTypography
                variant="subtitle2"
                fontStyle={{
                  fontWeight: "bold",
                  color: "white",
                }}
              >
                {t("rischio.rischioForm.cstSpRsk")}
              </ExtendedTypography>
            </TableCell>
            <TableCell align="center" width="15%">
              <ExtendedTypography
                variant="subtitle2"
                fontStyle={{
                  fontWeight: "bold",
                  color: "white",
                }}
              >
                {subTotaleA}
              </ExtendedTypography>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};
